import { getTask, getTaskGroupOpenTasks } from '../services/store-service';
import { resolveMilestones, getMilestoneType } from './milestone';
import { isTempId } from './helpers';

import { fetchTask, updateTask, reorderTasks } from '../actions/tasks';

export const resolveTasks = (taskIds, forcePromise, forceArray) => {
    let shouldFetch = false;

    const tasks = taskIds.map(task => task.id || task).map(taskId => {
        const task = getTask(taskId);

        if (!task) {
            shouldFetch = true;

            return fetchTask(taskId);
        }

        return task;
    });

    if (forceArray) {
        return tasks.filter(task => !(task instanceof Promise));
    }

    if (!shouldFetch) {
        if (forcePromise) {
            return Promise.resolve(tasks);
        }

        return tasks;
    } else {
        return Promise.all(tasks);
    }
}

export const moveTasks = (taskGroupId, taskId, order, { archived = false, completed = false } = {}) => {
    const taskGroupTasks = getTaskGroupOpenTasks(taskGroupId);

    const newOrder = taskGroupTasks
        .filter(t => t.id !== taskId);

    newOrder.splice(order, 0, {
        id: taskId
    });

    updateTask(taskId, {
        task_group: taskGroupId,
        archived,
        completed
    }, true);

    reorderTasks(newOrder.map(({ id }, order) => ({
        id,
        order
    })));
}

const isMilestoneDependant = (task, withDetails) => {
    if (task && task.milestone) {
        const milestone = resolveMilestones([task.milestone], false, true)[0];

        if (!milestone || !milestone.dependency) {
            return false;
        }

        const milestoneDep = resolveMilestones([milestone.dependency], false, true)[0];

        if (!milestoneDep) {
            return false;
        }

        const isMilestoneDependant = Boolean(getMilestoneType(milestoneDep) !== 'completed');

        if (!withDetails) {
            return isMilestoneDependant;
        }

        if (isMilestoneDependant) {
            return {
                type: 'milestone',
                id: milestoneDep.id
            };
        }
    }

    return false;
}

const isTaskDepenendant = (task, withDetails) => {
    if (task && task.dependency) {
        const depTask = resolveTasks([task.dependency], false, true)[0];

        if (!depTask || depTask.completed) {
            return false;
        }

        if (!withDetails) {
            return true;
        }

        return {
            type: 'task',
            id: task.dependency
        };

    }

    return false;
}

export const isDependant = (taskId, withDetails) => {
    if (!taskId || isTempId(taskId)) {
        return false;
    }

    const task = resolveTasks([taskId], false, true)[0];

    return isMilestoneDependant(task, withDetails) || isTaskDepenendant(task, withDetails);
}

export const testTaskDueDateFilter = (dueDateFilter, task) => {
    if (!dueDateFilter || !task || !task.due_date) {
        return false;
    }

    const dueDateStart = dueDateFilter.start ? dueDateFilter.start : 0;
    const dueDateEnd = dueDateFilter.end ? dueDateFilter.end : Number.POSITIVE_INFINITY;
    const taskDueDate = new Date(task.due_date).getTime();

    if (!(taskDueDate >= dueDateStart && taskDueDate <= dueDateEnd)) {
        return false;
    }

    return true;
}

export const filterTask = (task, filter) => {
    if (!task) {
        return null;
    }

    if (filter.term && (task.name || '').toLowerCase().indexOf(filter.term.toLowerCase()) === -1) {
        return null;
    }

    if (filter.project && (task.project !== filter.project)) {
        return null;
    }

    if (filter.user) {
        if (filter.user === 'unassigned') {
            if ((task.assignees || []).length) {
                return null;
            }
        } else if (!(task.assignees || []).includes(filter.user)) {
            return null;
        }
    }

    if (filter.milestone && (task.milestone !== filter.milestone)) {
        return null;
    }

    if (filter.label && !(task.labels || []).includes(filter.label)) {
        return null;
    }

    if (filter.dueDate && !testTaskDueDateFilter(filter.dueDate, task)) {
        return null;
    }

    return task;
}
